import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import cogoToast from 'cogo-toast';
import Avatar from 'react-avatar';
import {withRouter} from 'react-router-dom';

import SectionTitle from 'components/dashboard/SectionTitle';
import EmptyArea from 'components/dashboard/EmptyArea';
import UsersAPI from 'api/users';
import Util from 'service/util';

export default withRouter((props) => {
    const classes = useStyles();

    const [recentViewers,
        setRecentViewers] = useState(null);
    const [page,
        setPage] = React.useState(0);
    const pageSize = props.pageSize || 7;

    useEffect(() => {
        getRecentViewers();
    }, []);

    const getRecentViewers = async() => {
        try {
            const res = await UsersAPI.getBroadcasterRecentViewers();
            const {data, err} = res;

            if (err) {
                throw new Error('Error getting recent viewers: ', err);
            }

            setRecentViewers(data.viewers);
        } catch (err) {
            console.error('Error getting recent viewers: ', err);
            cogoToast.error('Problem getting recent viewers');
            setRecentViewers([]);
        }
    }

    const [selectedRecentViewers,
        setSelectedRecentViewers] = useState(props.selected || []);

    const getRecentViewerIndex = (ID) => {
        if (!selectedRecentViewers || selectedRecentViewers.length === 0) {
            return -1;
        }

        return selectedRecentViewers.findIndex(s => s._id === ID);
    }

    const handleSelect = (recentViewer) => {
        let s = selectedRecentViewers;
        const i = getRecentViewerIndex(recentViewer._id);

        if (i === -1) {
            s.push(recentViewer);
        } else {
            s.splice(i, 1);
        }

        setSelectedRecentViewers([...s]);
        props.onUpdateSelection([...s])
    }

    const handleSelectAll = (event) => {
        const s = event.target.checked
            ? [...recentViewers]
            : [];
        setSelectedRecentViewers(s);
        props.onUpdateSelection(s);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleViewAll = () => {
        props
            .history
            .push('/app/g/recentViewersGroup');
    }

    const rowCount = recentViewers
        ? recentViewers.length
        : 0;
    let numSelected = selectedRecentViewers.length;
    const hasRecentViewers = Array.isArray(recentViewers) && recentViewers.length > 0;

    return (
        <div>
            <section className={classes.titleContainer}>
                <SectionTitle title={props.title}/> {/*  */}

                {(hasRecentViewers && props.showViewAll) && <span className={classes.viewAll} onClick={handleViewAll}>View all</span>}
            </section>

            {(!recentViewers) && <EmptyArea title="Loading recent viewers"/>}

            {(Array.isArray(recentViewers) && recentViewers.length === 0) && <EmptyArea title="No Recent Viewers"/>}

            {(hasRecentViewers) && <TableContainer className={classes.tableContainer} component={Paper}>
                <Table
                    className={classes.table}
                    style={{
                    ...props.tableStyle
                }}>
                    <TableHead>
                        <TableRow>
                            {props.selection && (
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        indeterminate={numSelected > 0 && numSelected < rowCount}
                                        checked={rowCount > 0 && numSelected === rowCount}
                                        onChange={handleSelectAll}
                                        color="primary"
                                        inputProps={{
                                        'aria-label': 'select all recent viewers'
                                    }}/>
                                </TableCell>
                            )}
                            <TableCell size="small" padding="none"></TableCell>
                            <TableCell
                                style={{
                                paddingLeft: 0
                            }}>Name</TableCell>
                            {props.email && (
                                <TableCell>Email</TableCell>
                            )}
                            <TableCell align="right">Position</TableCell>
                            {props.profile && (
                                <TableCell align="right"></TableCell>
                            )}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {recentViewers
                            .slice(page * pageSize, page * pageSize + pageSize)
                            .map((s) => {
                                const isSelected = getRecentViewerIndex(s._id) !== -1
                                    ? true
                                    : false;

                                return (
                                    <TableRow
                                        key={s._id}
                                        hover
                                        role="checkbox"
                                        selected={isSelected}
                                        aria-checked={isSelected}>
                                        {props.selection && (
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    color="primary"
                                                    checked={isSelected}
                                                    onClick={() => handleSelect(s)}
                                                    inputProps={{
                                                    'aria-labelledby': s._id
                                                }}/>
                                            </TableCell>
                                        )}
                                        <TableCell
                                            component="th"
                                            scope="row"
                                            size="small"
                                            padding="none"
                                            style={{
                                            textAlign: 'center'
                                        }}>
                                            <Avatar
                                                src={Util.getDisplayableAvatar(s.profileImg)}
                                                name={`${s.firstName} ${s.lastName}`}
                                                round={true}
                                                size='35'/>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                            paddingLeft: 0
                                        }}>
                                            {`${s.firstName} ${s.lastName}`}
                                        </TableCell>
                                        {props.email && (
                                            <TableCell>{s.email}</TableCell>
                                        )}
                                        <TableCell align="right">{s.position}</TableCell>
                                        {props.profile && (
                                            <TableCell
                                                align="right"
                                                className="cursor-pointer hover_color-blue"
                                                onClick={() => props.onViewProfile(s)}>View Profile</TableCell>
                                        )}
                                    </TableRow>
                                )
                            })}
                    </TableBody>
                </Table>

                <TablePagination
                    className={classes.tablePagination}
                    component="div"
                    count={recentViewers.length}
                    rowsPerPage={pageSize}
                    rowsPerPageOptions={[pageSize]}
                    page={page}
                    onChangePage={handleChangePage}/>
            </TableContainer>}
        </div>
    );
});

const useStyles = makeStyles({
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    viewAll: {
        fontSize: '14px',
        '&:hover': {
            cursor: 'pointer',
            color: '#0ca3d9'
        }
    },
    tableContainer: {
        marginBottom: 25,
        minHeight: 300,
        paddingBottom: 55, //to make space for pagination
        position: 'relative'
    },
    tablePagination: {
        position: 'absolute',
        bottom: 0,
        right: 0
    }
});
